import VueRouter from 'vue-router';

class AppInstances {
  public static router: VueRouter = null;
}

export default AppInstances;
